import { render } from "./editVersio.vue?vue&type=template&id=03005fc1&scoped=true"
import script from "./editVersio.vue?vue&type=script&lang=js"
export * from "./editVersio.vue?vue&type=script&lang=js"

import "./editVersio.vue?vue&type=style&index=0&id=03005fc1&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03005fc1"]])

export default __exports__